export default function IconSave() {
    return (
        <svg
            width={159}
            height={118}
            viewBox="0 0 159 118"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.1"
                d="M141.907 56.9169C138.5 64.365 142.156 73.0633 146.596 79.6465C148.083 81.8502 149.729 84.1643 149.839 86.904C149.974 90.2531 147.728 93.2952 145.123 95.2657C140.373 98.8574 134.034 99.8945 128.616 97.9567C123.941 96.2841 120.085 92.6164 115.358 91.0858C107.448 88.5257 98.8199 92.4297 91.7803 97.3524C86.7999 100.835 81.442 105.08 75.6251 104.228C71.5318 103.629 68.1579 100.504 65.927 96.8514C64.8499 95.0879 63.9289 93.1174 62.3071 91.9136C61.3428 91.198 60.1946 90.8075 59.0409 90.5251C48.5111 87.9444 37.017 93.6593 26.6516 90.4661C19.6533 88.3092 14.2321 82.2717 10.9824 75.3687C7.73266 68.4656 6.38809 60.7053 5.31469 53.0213C4.55189 47.5606 3.96937 41.6726 6.38864 36.6963C8.94756 31.4348 14.5281 28.3083 20.0357 27.7915C25.5433 27.2747 30.9829 29.0224 35.9468 31.4559C42.1531 34.4883 48.1846 38.6949 55.0752 38.8173C59.7686 38.9003 64.3162 37.0557 68.8601 35.6654C76.456 33.3427 84.3026 32.2516 92.1216 31.2562C99.6065 30.3032 107.161 29.4213 114.625 30.1715C119.907 30.7025 124.503 32.9285 129.607 34.0045C132.933 34.7059 136.32 34.2752 139.561 35.4209C143.56 36.8308 147.608 40.0176 147.645 44.936C147.686 49.6098 143.717 52.9635 141.907 56.9169Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M111.361 64.9686C111.361 64.9686 111.578 58.5599 115.045 54.9386C116.5 53.419 117.456 51.4891 117.709 49.4005C117.827 48.4092 117.855 47.4093 117.79 46.4131"
                stroke="#535461"
                strokeWidth="1.2807"
                strokeMiterlimit={10}
            />
            <path
                opacity="0.5"
                d="M119.963 44.1192C119.725 44.8351 117.742 46.4792 117.742 46.4792C117.742 46.4792 117.134 43.9743 117.371 43.2591C117.428 43.089 117.517 42.9316 117.634 42.796C117.752 42.6604 117.895 42.5492 118.055 42.4688C118.215 42.3884 118.389 42.3403 118.568 42.3273C118.747 42.3143 118.927 42.3367 119.097 42.3931C119.267 42.4496 119.424 42.539 119.56 42.6562C119.696 42.7735 119.807 42.9163 119.887 43.0765C119.968 43.2367 120.016 43.4112 120.029 43.59C120.042 43.7688 120.019 43.9484 119.963 44.1186V44.1192Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M120.787 48.7932C120.197 49.2652 117.641 49.5681 117.641 49.5681C117.641 49.5681 118.493 47.1353 119.083 46.664C119.222 46.5432 119.383 46.4517 119.558 46.395C119.733 46.3383 119.918 46.3176 120.101 46.3341C120.285 46.3506 120.463 46.404 120.625 46.491C120.787 46.578 120.93 46.6969 121.044 46.8405C121.159 46.9842 121.244 47.1495 121.294 47.3267C121.343 47.5039 121.356 47.6893 121.332 47.8717C121.308 48.0541 121.247 48.2297 121.154 48.3881C121.06 48.5465 120.936 48.6843 120.787 48.7932Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M118.45 55.5347C117.704 55.6449 115.342 54.6169 115.342 54.6169C115.342 54.6169 117.305 52.9466 118.051 52.8365C118.228 52.8102 118.409 52.8192 118.583 52.8629C118.756 52.9065 118.92 52.984 119.064 53.0908C119.208 53.1977 119.329 53.3319 119.421 53.4857C119.514 53.6395 119.574 53.8099 119.601 53.9873C119.627 54.1646 119.618 54.3454 119.574 54.5193C119.531 54.6931 119.453 54.8567 119.346 55.0007C119.239 55.1446 119.105 55.2661 118.951 55.3582C118.798 55.4502 118.627 55.5111 118.45 55.5373V55.5347Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M115.529 60.2379C114.813 60.4726 112.311 59.8564 112.311 59.8564C112.311 59.8564 113.963 57.8786 114.68 57.6439C115.024 57.5309 115.399 57.5591 115.722 57.7225C116.045 57.8858 116.29 58.1708 116.403 58.5148C116.516 58.8588 116.488 59.2336 116.324 59.5567C116.161 59.8799 115.876 60.1249 115.532 60.2379H115.529Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M114.874 48.8046C115.222 49.4733 117.445 50.7824 117.445 50.7824C117.445 50.7824 117.646 48.2133 117.298 47.544C117.216 47.385 117.102 47.2438 116.965 47.1286C116.828 47.0133 116.669 46.9263 116.498 46.8723C116.327 46.8184 116.147 46.7987 115.969 46.8143C115.79 46.8298 115.617 46.8804 115.458 46.9632C115.299 47.0459 115.157 47.1591 115.042 47.2964C114.927 47.4337 114.84 47.5923 114.786 47.7633C114.732 47.9342 114.712 48.1141 114.728 48.2927C114.743 48.4712 114.794 48.645 114.877 48.804L114.874 48.8046Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M111.531 54.347C112.063 54.8813 114.573 55.466 114.573 55.466C114.573 55.466 113.996 52.9539 113.465 52.4196C113.209 52.1632 112.862 52.0187 112.5 52.0181C112.138 52.0174 111.791 52.1605 111.534 52.416C111.278 52.6715 111.133 53.0184 111.133 53.3804C111.132 53.7424 111.275 54.0899 111.531 54.3463V54.347Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M109.02 60.1813C109.454 60.7976 111.829 61.7986 111.829 61.7986C111.829 61.7986 111.686 59.2255 111.251 58.6087C111.151 58.4557 111.021 58.3246 110.868 58.223C110.716 58.1215 110.545 58.0516 110.365 58.0175C110.185 57.9834 110 57.9859 109.821 58.0247C109.643 58.0635 109.473 58.1379 109.324 58.2435C109.174 58.349 109.048 58.4836 108.951 58.6391C108.855 58.7946 108.79 58.968 108.762 59.1489C108.734 59.3297 108.743 59.5144 108.787 59.6919C108.832 59.8694 108.912 60.036 109.023 60.182L109.02 60.1813Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M112.124 62.316C112.124 62.316 110.157 59.4551 110.502 56.7634C110.654 55.6353 110.436 54.4884 109.881 53.4948C109.613 53.0252 109.303 52.5811 108.955 52.168"
                stroke="#535461"
                strokeWidth="1.2807"
                strokeMiterlimit={10}
            />
            <path
                opacity="0.5"
                d="M109.162 50.4698C109.289 50.8579 108.954 52.2123 108.954 52.2123C108.954 52.2123 107.884 51.3168 107.757 50.9293C107.696 50.743 107.712 50.5402 107.801 50.3654C107.889 50.1907 108.044 50.0583 108.23 49.9975C108.417 49.9366 108.619 49.9523 108.794 50.041C108.969 50.1297 109.101 50.2842 109.162 50.4704V50.4698Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M111.026 52.2398C110.922 52.6331 109.904 53.5896 109.904 53.5896C109.904 53.5896 109.493 52.2562 109.597 51.8616C109.647 51.672 109.771 51.5102 109.94 51.4117C110.109 51.3131 110.311 51.286 110.501 51.3361C110.69 51.3863 110.852 51.5097 110.951 51.6792C111.049 51.8486 111.076 52.0503 111.026 52.2398Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M112.175 55.928C111.886 56.2158 110.525 56.5272 110.525 56.5272C110.525 56.5272 110.843 55.1682 111.132 54.8804C111.201 54.812 111.283 54.7578 111.373 54.7209C111.463 54.684 111.559 54.6652 111.656 54.6655C111.753 54.6658 111.849 54.6853 111.939 54.7227C112.028 54.7601 112.11 54.8149 112.178 54.8837C112.246 54.9526 112.301 55.0343 112.338 55.1241C112.374 55.2139 112.393 55.3101 112.393 55.4072C112.393 55.5043 112.373 55.6004 112.336 55.69C112.298 55.7796 112.244 55.8609 112.175 55.9293V55.928Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M112.418 58.915C112.181 59.2474 110.891 59.783 110.891 59.783C110.891 59.783 110.974 58.3899 111.211 58.0576C111.267 57.9784 111.338 57.9112 111.42 57.8596C111.502 57.808 111.594 57.7731 111.69 57.7569C111.785 57.7407 111.883 57.7436 111.978 57.7652C112.073 57.7869 112.162 57.827 112.241 57.8832C112.32 57.9394 112.387 58.0106 112.439 58.0929C112.491 58.1751 112.526 58.2666 112.542 58.3623C112.558 58.458 112.555 58.556 112.533 58.6506C112.512 58.7452 112.472 58.8346 112.415 58.9137L112.418 58.915Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M108.453 54.1453C108.82 54.3249 110.208 54.1807 110.208 54.1807C110.208 54.1807 109.469 52.9967 109.102 52.8178C108.926 52.7317 108.723 52.7191 108.538 52.7827C108.353 52.8463 108.2 52.981 108.114 53.157C108.028 53.333 108.015 53.5361 108.079 53.7214C108.143 53.9067 108.277 54.0592 108.453 54.1453Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M108.782 57.636C109.186 57.6976 110.467 57.145 110.467 57.145C110.467 57.145 109.408 56.2364 109.004 56.1773C108.811 56.1479 108.613 56.1966 108.455 56.3128C108.297 56.4289 108.192 56.6031 108.163 56.7969C108.133 56.9906 108.182 57.1882 108.298 57.346C108.414 57.5039 108.588 57.6091 108.782 57.6386V57.636Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M109.563 60.9844C109.95 61.1155 111.307 60.7877 111.307 60.7877C111.307 60.7877 110.416 59.7132 110.029 59.5841C109.843 59.5223 109.64 59.5369 109.465 59.6247C109.289 59.7126 109.156 59.8664 109.094 60.0525C109.033 60.2385 109.047 60.4415 109.135 60.6167C109.223 60.792 109.377 60.9252 109.563 60.987V60.9844Z"
                fill="#7B67FB"
            />
            <path
                opacity="0.5"
                d="M109.162 50.4698C109.289 50.8579 108.954 52.2123 108.954 52.2123C108.954 52.2123 107.884 51.3168 107.757 50.9293C107.696 50.743 107.712 50.5402 107.801 50.3654C107.889 50.1907 108.044 50.0583 108.23 49.9975C108.417 49.9366 108.619 49.9523 108.794 50.041C108.969 50.1297 109.101 50.2842 109.162 50.4704V50.4698Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M111.026 52.2398C110.922 52.6331 109.904 53.5896 109.904 53.5896C109.904 53.5896 109.493 52.2562 109.597 51.8616C109.647 51.672 109.771 51.5102 109.94 51.4117C110.109 51.3131 110.311 51.286 110.501 51.3361C110.69 51.3863 110.852 51.5097 110.951 51.6792C111.049 51.8486 111.076 52.0503 111.026 52.2398Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M112.175 55.928C111.886 56.2158 110.525 56.5272 110.525 56.5272C110.525 56.5272 110.843 55.1682 111.132 54.8804C111.201 54.812 111.283 54.7578 111.373 54.7209C111.463 54.684 111.559 54.6652 111.656 54.6655C111.753 54.6658 111.849 54.6853 111.939 54.7227C112.028 54.7601 112.11 54.8149 112.178 54.8837C112.246 54.9526 112.301 55.0343 112.338 55.1241C112.374 55.2139 112.393 55.3101 112.393 55.4072C112.393 55.5043 112.373 55.6004 112.336 55.69C112.298 55.7796 112.244 55.8609 112.175 55.9293V55.928Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M112.418 58.915C112.181 59.2474 110.891 59.783 110.891 59.783C110.891 59.783 110.974 58.3899 111.211 58.0576C111.267 57.9784 111.338 57.9112 111.42 57.8596C111.502 57.808 111.594 57.7731 111.69 57.7569C111.785 57.7407 111.883 57.7436 111.978 57.7652C112.073 57.7869 112.162 57.827 112.241 57.8832C112.32 57.9394 112.387 58.0106 112.439 58.0929C112.491 58.1751 112.526 58.2666 112.542 58.3623C112.558 58.458 112.555 58.556 112.533 58.6506C112.512 58.7452 112.472 58.8346 112.415 58.9137L112.418 58.915Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M108.453 54.1453C108.82 54.3249 110.208 54.1807 110.208 54.1807C110.208 54.1807 109.469 52.9967 109.102 52.8178C108.926 52.7317 108.723 52.7191 108.538 52.7827C108.353 52.8463 108.2 52.981 108.114 53.157C108.028 53.333 108.015 53.5361 108.079 53.7214C108.143 53.9067 108.277 54.0592 108.453 54.1453Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M108.782 57.636C109.186 57.6976 110.467 57.145 110.467 57.145C110.467 57.145 109.408 56.2364 109.004 56.1773C108.811 56.1479 108.613 56.1966 108.455 56.3128C108.297 56.4289 108.192 56.6031 108.163 56.7969C108.133 56.9906 108.182 57.1882 108.298 57.346C108.414 57.5039 108.588 57.6091 108.782 57.6386V57.636Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M109.563 60.9844C109.95 61.1155 111.307 60.7877 111.307 60.7877C111.307 60.7877 110.416 59.7132 110.029 59.5841C109.843 59.5223 109.64 59.5369 109.465 59.6247C109.289 59.7126 109.156 59.8664 109.094 60.0525C109.033 60.2385 109.047 60.4415 109.135 60.6167C109.223 60.792 109.377 60.9252 109.563 60.987V60.9844Z"
                fill="white"
            />
            <path
                opacity="0.5"
                d="M108.484 70.0732H114.078L115.477 61.5425H107.086L108.484 70.0732Z"
                fill="#474059"
            />
            <path
                opacity="0.1"
                d="M108.156 61.5425L109.463 69.5141H114.17L114.078 70.0732H108.484L107.086 61.5425H108.156Z"
                fill="black"
            />
            <path
                d="M109.546 21.4434H68.5078V70.9576H109.546V21.4434Z"
                fill="url(#paint0_linear_441_16445)"
            />
            <path
                d="M109.022 22.0762H69.0332V70.3252H109.022V22.0762Z"
                fill="white"
            />
            <rect
                x="75.4842"
                y="26.871"
                width="4.48246"
                height="4.48246"
                rx="0.320175"
                stroke="#E7ECF7"
                strokeWidth="0.640351"
            />
            <rect
                x="75.4842"
                y="58.8885"
                width="4.48246"
                height="4.48246"
                rx="0.320175"
                stroke="#E7ECF7"
                strokeWidth="0.640351"
            />
            <rect
                x="75.4842"
                y="42.8797"
                width="4.48246"
                height="4.48246"
                rx="0.320175"
                stroke="#E7ECF7"
                strokeWidth="0.640351"
            />
            <path
                d="M100.695 27.5171H84.5684V28.3038H100.695V27.5171Z"
                fill="#C0BCCF"
            />
            <path
                d="M100.695 30.0088H84.5684V30.7955H100.695V30.0088Z"
                fill="#C0BCCF"
            />
            <path
                opacity="0.5"
                d="M100.695 59.1152H84.5684V59.9019H100.695V59.1152Z"
                fill="#C0BCCF"
            />
            <path
                opacity="0.5"
                d="M100.695 61.6064H84.5684V62.3931H100.695V61.6064Z"
                fill="#C0BCCF"
            />
            <path
                opacity="0.5"
                d="M96.8267 64.0972H88.4355V64.8838H96.8267V64.0972Z"
                fill="#7B67FB"
            />
            <g clipPath="url(#clip0_441_16445)">
                <path
                    d="M83.0665 55.7623L74.8281 47.5239C73.944 46.6398 72.7449 46.1431 71.4946 46.1431H45.1616C42.5579 46.1431 40.4473 48.2537 40.4473 50.8574V85.4288C40.4473 88.0324 42.5579 90.1431 45.1616 90.1431H79.733C82.3366 90.1431 84.4473 88.0324 84.4473 85.4288V59.0958C84.4473 57.8455 83.9506 56.6464 83.0665 55.7623ZM62.4473 83.8574C58.9758 83.8574 56.1616 81.0431 56.1616 77.5716C56.1616 74.1002 58.9758 71.2859 62.4473 71.2859C65.9187 71.2859 68.733 74.1002 68.733 77.5716C68.733 81.0431 65.9187 83.8574 62.4473 83.8574ZM71.8758 53.9491V63.8216C71.8758 64.4725 71.3481 65.0002 70.6973 65.0002H47.9116C47.2607 65.0002 46.733 64.4725 46.733 63.8216V53.6074C46.733 52.9565 47.2607 52.4288 47.9116 52.4288H70.3555C70.6681 52.4288 70.9678 52.5529 71.1888 52.774L71.5306 53.1158C71.6401 53.2252 71.7269 53.3551 71.7861 53.4981C71.8454 53.6411 71.8759 53.7944 71.8758 53.9491Z"
                    fill="#7B67FB"
                />
            </g>
            <path
                d="M91.1983 56.0001C92.1642 56.0001 92.9473 55.217 92.9473 54.251C92.9473 53.285 92.1642 52.502 91.1983 52.502C90.2323 52.502 89.4492 53.285 89.4492 54.251C89.4492 55.217 90.2323 56.0001 91.1983 56.0001Z"
                fill="#F19920"
            />
            <path
                d="M91.011 36.0001C88.2775 36.0194 86.0393 38.2408 86.0005 40.9741C86.0001 40.9994 86 41.1768 86 41.4089C86 41.7492 86.1352 42.0755 86.3758 42.3161C86.6164 42.5568 86.9428 42.692 87.283 42.692H87.283C87.4517 42.692 87.6187 42.6587 87.7746 42.5941C87.9304 42.5295 88.0719 42.4348 88.1912 42.3155C88.3104 42.1961 88.4049 42.0544 88.4693 41.8986C88.5338 41.7427 88.5669 41.5756 88.5667 41.4069C88.5666 41.2491 88.5665 41.1398 88.5665 41.1331C88.5664 40.7106 88.6763 40.2955 88.8854 39.9284C89.0944 39.5613 89.3954 39.255 89.7587 39.0395C90.1221 38.824 90.5353 38.7068 90.9576 38.6995C91.38 38.6921 91.797 38.7948 92.1676 38.9975C92.5383 39.2002 92.8497 39.4959 93.0714 39.8555C93.2931 40.2151 93.4174 40.6262 93.432 41.0483C93.4466 41.4705 93.3511 41.8892 93.1548 42.2633C92.9585 42.6374 92.6683 42.9539 92.3125 43.1817L92.313 43.1823C92.313 43.1823 90.4868 44.3579 89.9301 45.9707L89.9305 45.9708C89.8326 46.3012 89.783 46.644 89.7833 46.9886C89.7833 47.1302 89.7916 48.3696 89.8077 49.3756C89.8133 49.7227 89.9552 50.0536 90.2026 50.2971C90.4501 50.5405 90.7834 50.6769 91.1305 50.6768H91.1305C91.3049 50.6768 91.4776 50.6423 91.6387 50.5753C91.7997 50.5083 91.9459 50.4101 92.0689 50.2864C92.1918 50.1627 92.2891 50.0159 92.3551 49.8544C92.4211 49.6929 92.4545 49.52 92.4535 49.3456C92.4479 48.4243 92.4449 47.3516 92.4449 47.2738C92.4449 46.2835 93.4002 45.2968 94.1849 44.6533C95.0886 43.9124 95.7388 42.9026 96 41.7636C96.0578 41.5291 96.0897 41.289 96.095 41.0475C96.095 40.3816 95.9633 39.7223 95.7073 39.1075C95.4514 38.4927 95.0763 37.9347 94.6037 37.4655C94.1312 36.9963 93.5704 36.6253 92.9538 36.3738C92.3372 36.1223 91.677 35.9953 91.011 36.0001Z"
                fill="#F19920"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_441_16445"
                    x1="89.0268"
                    y1="70.9583"
                    x2="89.0268"
                    y2="21.4434"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#808080" stopOpacity="0.25" />
                    <stop
                        offset="0.54"
                        stopColor="#808080"
                        stopOpacity="0.12"
                    />
                    <stop offset={1} stopColor="#808080" stopOpacity="0.1" />
                </linearGradient>
                <clipPath id="clip0_441_16445">
                    <rect
                        width={44}
                        height="50.2857"
                        fill="white"
                        transform="translate(40.4473 43)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
